const normalizeAddressString = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const getComparablePlaceId = (location = {}) =>
  String(location?.place_id || location?.placeId || "")
    .trim()
    .toLowerCase();

const getComparableAddress = (location = {}) =>
  normalizeAddressString(location?.address || location?.text || location?.description || "");

export const areLocationsSame = (firstLocation = {}, secondLocation = {}) => {
  const firstPlaceId = getComparablePlaceId(firstLocation);
  const secondPlaceId = getComparablePlaceId(secondLocation);

  if (firstPlaceId && secondPlaceId) {
    return firstPlaceId === secondPlaceId;
  }

  const firstAddress = getComparableAddress(firstLocation);
  const secondAddress = getComparableAddress(secondLocation);

  if (!firstAddress || !secondAddress) {
    return false;
  }

  return firstAddress === secondAddress;
};

export const arePickupAndDropSame = (pickup = {}, drop = {}) =>
  areLocationsSame(pickup, drop);

export const hasDuplicateLocations = (locations = []) => {
  for (let index = 0; index < locations.length; index += 1) {
    for (let comparisonIndex = index + 1; comparisonIndex < locations.length; comparisonIndex += 1) {
      if (areLocationsSame(locations[index], locations[comparisonIndex])) {
        return true;
      }
    }
  }

  return false;
};

export const validateUniqueLocations = (
  locations = [],
  toast,
  message = "Can't use same address for multiple stops."
) => {
  if (hasDuplicateLocations(locations)) {
    toast?.error?.(message);
    return false;
  }

  return true;
};

export const validateDifferentPickupAndDrop = (pickup = {}, drop = {}, toast) => {
  const isSameLocation = areLocationsSame(pickup, drop);

  if (isSameLocation) {
    toast?.error?.("Pickup and drop location cannot be the same.");
    return false;
  }

  return true;
};
